export const CONVERT_STATUS_PENDING = [50, 40, 10]
export const CONVERT_STATUS_FAIL = [11, 20, 21, 41, 70]
export const CONVERT_STATUS_SUCCESS = [60]

export const CONVERT_SERVER_ERROR_CODE = [
  110200, 110900, 110005, 110920, 110922, 110009, 110011, 110052, 110012,
  110013, 110014, 110015, 110017, 110018, 110090, 110019, 110020, 110923,
  110910, 110021, 110022, 110911, 110031, 110023, 110024, 110201, 110924,
  110203, 500,
]
export const CONVERT_TRY_AGAIN_ERROR_CODE = [1003]
export const CONVERT_TRY_AGAIN_ERROR_CODE_HASH: { [index: string]: string } = {
  OPERATION_FAILED: 'a73f39b',
  SYMBOL_NOT_FOUND: 'f50d713',
  ACCOUNT_NO_ENOUGH_BALANCE: '64e573a',
  TRADE_AMOUNT_INVALID: '848023c',
}

const convertErrorCode = {
  ErrCodeDbQueryError: 110900,
  ErrCodeDbQueryNotFound: 110901,
  ErrCodeDbUpdateError: 110902,
  ErrCodeDbUpdateEffectively: 110903,
  ErrCodeDbInsertError: 110904,
  ErrCodeDbDeleteError: 110906,
  ErrCodeDbDeleteEffectively: 110907,
  ErrCodeDbTransactionBegin: 110910,
  ErrCodeDbTransactionCommit: 110911,
  ErrCodeBindJSON: 110920,
  ErrCodeUUIDFormat: 110921,
  ErrCodeInvalidParameter: 110922,
  ErrCodeJsonMarshal: 110923,
  ErrCodeJsonUnmarshal: 110924,
  ErrCodeGetRawRequestData: 110925,
  ErrCodeDecimalFromString: 110930,
  ErrCodeZKLayer2Request: 110800,
  ErrCodeZKLayer2ErrorResponse: 110801,
  ErrCodeValidAddressFormat: 110700,
  ErrCodeRecoverToAddress: 110701,
  ErrCodeAccessTokenNotFound: 110002,
  ErrCodeAccessTokenCheck: 110003,
  ErrCodeInvalidUserStatus: 110004,
  ErrCodeUserNotActiveInLayer2: 110005,
  ErrCodeUserRateLimitMapLoad: 110006,
  ErrCodeUserRateLimitReached: 110007,
  ErrCodeInvalidOrderTimeInForce: 110008,
  ErrCodeInvalidOrderFeeRatio: 110009,
  ErrCodeInvalidOrderCurrency: 110010,
  ErrCodeInvalidOrderLayer2UserId: 110011,
  ErrCodeInvalidOrderSlot: 110012,
  ErrCodeInvalidOrderNonce: 110013,
  ErrCodeInvalidOrderSize: 110014,
  ErrCodeInvalidOrderPrice: 110015,
  ErrCodeInvalidOrderFund: 110016,
  ErrCodeInvalidOrderPubKey: 110017,
  ErrCodeInvalidOrderSignature: 110018,
  ErrCodeInvalidPackOrder: 110019,
  ErrCodeInvalidVerifyOrderSignature: 110020,
  ErrCodeInvalidPlaceOrder: 110021,
  ErrCodeRedisFreeCachedSlot: 110022,
  ErrCodeRedisMGetCachedSlot: 110023,
  ErrCodeRedisSetNXToTakeSlot: 110024,
  ErrCodeRedisGetCachedTokens: 110025,
  ErrCodeInvalidAddAddressBook: 110026,
  ErrCodeInvalidOrderStopPrice: 110027,
  ErrCodeInvalidOrderStopCondition: 110028,
  ErrCodeCancelOrderErrOrderStatus: 110029,
  ErrCodeCancelOrderNotCompleteTrade: 110030,
  ErrCodeRunOutOfSlot: 110031,
  ErrCodeRunOutOfCachedSlot: 110032,
  ErrCodeInvalidOrderIsStop: 110033,
  ErrCodeInvalidOrderIsIceberg: 110034,
  ErrCodeInvalidOrderExposedSize: 110035,
  ErrCodeInvalidOrderClientOid: 110036,
  ErrCodeInvalidUserPubKey: 110040,
  ErrCodeAccessTokenRefresh: 110041,
  ErrCodeNoFeeRateRecord: 110051,
  ErrCodeNoFlashConfigRecord: 110052,
  ErrCodeProductNotOnline: 110061,
  ErrCodeRepeaterMethodNotAllow: 110070,
  ErrCodeRepeaterTxTypeNotAllow: 110071,
  ErrCodeRepeaterTxSubmit: 110072,
  ErrCodeRepeaterInvalidReqParam: 110073,
  ErrCodeRepeaterCalcTxHash: 110074,
  ErrCodeRepeaterZkSignTxHash: 110075,
  ErrCodeRepeaterSubAccountId: 110076,
  ErrCodeRepeaterAccountId: 110077,
  ErrCodeRepeaterCompetition: 110078,
  ErrCodeSubmitStopLimitOrder: 110080,
  ErrCodeSubmitOrder: 110081,
  ErrCodeDunkirkLaunchTime: 110090,
  ErrCodeRepeaterCheckNonce: 110100,
  ErrCodeRepeaterCheckBalance: 110101,
  ErrCodeRepeaterCheckToken: 110102,
  ErrCodeRepeaterCheckTxFee: 110103,
  ErrCodeNoValidFlashExchangeProvider: 110200,
  ErrCodeRequestFlashExchangeProvider: 110201,
  ErrCodeErrRespFlashExchangeProvider: 110202,
  ErrCodeInvalidFlashExchangeMakerOrder: 110203,
  ErrCodeEstimateTxFee: 110210,
}
/** 0 Service temporarily unavailable */
/** 1 Please try again later */

const ConvertAskPriceErrorMsg = {
  ErrCodeNoValidFlashExchangeProvider:
    'No valid flash exchange provider configured',
  ErrCodeInvalidParameter: 'Parameter validation error',
  ErrCodeDbQueryError: 'Database query error (unlikely to occur)',
  ErrCodeNoFlashConfigRecord: 'No flash exchange configuration record found',
  ErrCodeRequestFlashExchangeProvider:
    'Error requesting flash exchange provider (including connection failure and various business errors)',
  ErrCodeJsonUnmarshal: 'Error deserializing flash exchange provider response',
}

export interface ConvertFaqType {
  title: string
  article: string
}

const ConvertOrderErrorMsg = {
  ErrCodeNoValidFlashExchangeProvider:
    'No valid flash exchange provider configured',
  ErrCodeDbQueryError: 'Database query error (unlikely to occur)',
  ErrCodeUserNotActiveInLayer2: 'User not activated in Layer2', // 1
  ErrCodeBindJSON: 'Invalid input format',
  ErrCodeInvalidParameter: 'Parameter validation error',
  ErrCodeInvalidOrderFeeRatio: 'Invalid fee rate setting',
  ErrCodeInvalidOrderLayer2UserId:
    'Inconsistent user in taker order and order information',
  ErrCodeNoFlashConfigRecord: 'No flash exchange configuration record found',
  ErrCodeInvalidOrderSlot: 'Invalid slot in taker/maker order',
  ErrCodeInvalidOrderNonce: 'Invalid nonce in taker/maker order',
  ErrCodeInvalidOrderSize: 'Invalid size in taker/maker order',
  ErrCodeInvalidOrderPrice: 'Invalid price in taker/maker order',
  ErrCodeInvalidOrderPubKey: 'Invalid pubkey format in taker/maker order',
  ErrCodeInvalidOrderSignature: 'Invalid signature format in taker/maker order',
  ErrCodeDunkirkLaunchTime: 'Dunkirk is active',
  ErrCodeInvalidPackOrder: 'Failed to serialize order (unlikely to occur)',
  ErrCodeInvalidVerifyOrderSignature:
    'Signature verification failed for taker/maker order (incorrect signature)',
  ErrCodeJsonMarshal: 'Serialization error (unlikely to occur)',
  ErrCodeDbTransactionBegin:
    'Failed to start database transaction (unlikely to occur)',
  ErrCodeInvalidPlaceOrder:
    'Failed to place taker/maker order (including locking taker/maker assets, recording flash exchange information, and occupying slots in the database)',
  ErrCodeRedisFreeCachedSlot:
    'Failed to release cached slot in Redis (unlikely to occur)',
  ErrCodeDbTransactionCommit:
    'Failed to commit database transaction (unlikely to occur)',
  ErrCodeRunOutOfSlot: 'No available slots',
  ErrCodeRedisMGetCachedSlot:
    'Failed to read cached slot from Redis (unlikely to occur)',
  ErrCodeRedisSetNXToTakeSlot: 'Failed to set cached slot in Redis',
  ErrCodeRequestFlashExchangeProvider:
    'Error requesting flash exchange provider (including connection failure and various business errors)',
  ErrCodeJsonUnmarshal: 'Error deserializing flash exchange provider response',
  ErrCodeInvalidFlashExchangeMakerOrder:
    'Invalid maker order returned by flash exchange provider',
  // 1003
  OPERATION_FAILED: 'Hedge failed',
  SYMBOL_NOT_FOUND: 'Unsupported symbol',
  ACCOUNT_NO_ENOUGH_BALANCE: 'Insufficient balance', //1
  TRADE_AMOUNT_INVALID:
    'Invalid transaction amount, too large or exceeds order book depth', //1
  //   500
  INTERNAL_SERVER_ERROR: 'System exception',
}
export const ConvertFaq: ConvertFaqType[] = [
  {
    title: 'What is ZKEX Convert?',
    article:
      'ZKEX Convert is a simple trading tool for users to place market orders with a live price and to buy cryptocurrencies without having to learn the complex orderbook UI. ',
  },
  {
    title: 'What tokens and trading pairs does ZKEX Convert support?',
    article: `Currently ZKEX Convert support 3 tokens: USDT, WBTC, ETH; and the according pairs are: USDT—>WBTC, WBTC—>USDT, USDT—>ETH, ETH—>USDT, WBTC—>ETH, ETH—>WBTC.`,
  },
  {
    title: 'Do I need a ZKEX account to use ZKEX Convert?',
    article:
      'Yes, a ZKEX account is required before placing orders on ZKEX Convert. When you first connect web3 on ZKEX Convert, a ZKEX account will be automatically created.',
  },
  {
    title: 'How do I deposit assets to ZKEX Convert?',
    article: `
          ZKEX Convert is connected to your ZKEX account.<br />
      
          If you have the source token in your ZKEX address, you can directly trade with your account; if not, you will have to firstly deposit to ZKEX.
          `,
  },
  {
    title: 'What if I want to trade with a certain price?',
    article:
      'Currently ZKEX Convert only support market mode. For profession trading needs like limit orders, please go to <a href="/">ZKEX Order Book DEX </a>',
  },
  {
    title: 'Are there any trading fees?',
    article:
      'Yes. The convert fee references the taker fee rules and may vary with the user level and trading amount.',
  },
  {
    title: 'What are the minimum and maximum trade amounts?',
    article:
      'It depends on the pair you trade, and will be clearly listed once you select the pair and before you enter the amount.',
  },
  {
    title: 'Why is the quoted price different from the market price?',
    article: `
          The market price does not include trading fees or factor in the size of your trade. ZKEX Convert dynamically quotes the best prices (with no hidden fees) based on market conditions. The system will lock the quoted price for a short period for you to review before executing the trade.
          <br />
          The quoted amount of assets shown during the conversion preview is the actual amount of assets you will receive in your account. There are no additional fees on top of the price quoted.
          `,
  },
]
